import { Component, OnDestroy, OnInit } from '@angular/core';

import { SubSink } from 'subsink';

import { ConfigService } from '../../core/config/config.service';
import { FreyaNotificationsService } from '../../services/freya-notifications.service';

@Component({
  selector: 'app-communications',
  // standalone: true,
  // imports: [],
  templateUrl: './communications.component.html',
  styleUrl: './communications.component.scss'
})
export class CommunicationsComponent implements OnInit, OnDestroy {

  configQueryRef: ReturnType<typeof this.configService.watchConfigValues>;
  prompts: {
    businessHours: string;
    scheduleCommunicationsInstructions: string;
    scheduleCommunicationsRingGroups: string;
    inboundCallRoutingNumbers: string;
  } = undefined;

  subs = new SubSink();
  

  constructor(
    private configService: ConfigService,
    private localNotify: FreyaNotificationsService,
  ) { }

  ngOnInit(): void {
  
    this.configQueryRef = this.configService.watchConfigValues({
      keys: [
        'prompt.businessHours',
        'prompt.scheduleCommunicationsInstructions',
        'prompt.scheduleCommunicationsRingGroups',
        'prompt.inboundCallRoutingNumbers',
        // 'prompt.inboundCallRoutingNumbers',
      ],
    });

    this.subs.sink = this.configQueryRef.valueChanges
    .subscribe((res) => {
      const values = res.data?.getConfigValues;
      const pricingEngine = {} as typeof this.prompts;
      for (const value of values) {
        const [_, key]  = value.key.split('.');
        pricingEngine[key] = value.value;
      }

      this.prompts = pricingEngine;
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }


  updatePrompts() {
    
    const configs = Object.entries(this.prompts)
      .map(([ key, value ]) => {
        return {
          key: `prompt.${ key }`,
          value: (value || '') as string,
        };
      });

    this.subs.sink = this.configService.setConfigValues({
      configs,
    }).subscribe((res) => {
      this.localNotify.info(`Communication prompts updated.`);
    });
  }
}
